<mdt-dynamic-table
  [columns]="columns"
  [dataSource]="dataSource"
  [pageSize]="pageSize"
  [paginator]="paginator"
></mdt-dynamic-table>
